import axios from "axios";
import { reactive } from "vue";
const genplanStore = {
  state: reactive({
    data: null,
  }),
  setData() {
    axios
      .get(process.env.VUE_APP_NEW_API_GENPLAN)
      .then(({ data }) => (this.state.data = data.data))
      .catch(() => {});
  },
};
genplanStore.setData();
export default genplanStore;
